import React from 'react';
import Add2WalletLogo from './Add2WalletLogo';

// Proper terminal state for a bad/expired link — replaces both the old
// eternal spinner and the old fake-data fallback pass.
const ErrorState: React.FC<{
  title: string;
  message: string;
  canRetry?: boolean;
  onRetry?: () => void;
}> = ({ title, message, canRetry, onRetry }) => (
  <div className="max-w-md mx-auto px-4 py-16 text-center">
    <div className="w-14 h-14 mx-auto rounded-full bg-red-50 text-red-500 flex items-center justify-center mb-5">
      <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8v4M12 16h.01" />
      </svg>
    </div>
    <h1 className="text-xl font-bold text-gray-900 mb-2">{title}</h1>
    <p className="text-sm text-gray-600 mb-6">{message}</p>
    {canRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center justify-center px-6 h-11 rounded-full bg-[#AEDD1F] text-[#06251B] text-sm font-semibold hover:bg-[#9CCB1B] transition"
      >
        Try again
      </button>
    )}
    <div className="mt-10 flex justify-center opacity-60">
      <Add2WalletLogo size={20} />
    </div>
  </div>
);

export default ErrorState;
